export const l10nEn = {
    general: {
        dateTime: {
            date: 'Date',
            time: 'Time',
            dateTime: 'Date and time',
            startDate: 'Start date',
            endDate: 'End date',
            createdAt: 'Created at',
            updatedAt: 'Last updated at',
            today: 'Today',
            yesterday: 'Yesterday',
            tomorrow: 'Tomorrow',
            now: 'Now',
            never: 'Never',
            allDay: 'All day',
        },

        common: {
            id: 'ID',
            name: 'Name',
            title: 'Title',
            description: 'Description',
            type: 'Type',
            status: 'Status',
            state: 'State',
            category: 'Category',
            priority: 'Priority',
            value: 'Value',
            number: 'Number',
            code: 'Code',
            color: 'Color',
            label: 'Label',
            note: 'Note',
            notes: 'Notes',
            comment: 'Comment',
            comments: 'Comments',
            details: 'Details',
            information: 'Information',
            settings: 'Settings',
            options: 'Options',
            properties: 'Properties',
            items: 'Items',
            total: 'Total',
            count: 'Count',
            amount: 'Amount',
            unknown: 'Unknown',
            none: 'None',
            empty: 'Empty',
            all: 'All',
            yes: 'Yes',
            no: 'No',
        },

        actions: {
            add: 'Add',
            create: 'Create',
            edit: 'Edit',
            update: 'Update',
            delete: 'Delete',
            remove: 'Remove',
            save: 'Save',
            cancel: 'Cancel',
            close: 'Close',
            confirm: 'Confirm',
            apply: 'Apply',
            reset: 'Reset',
            clear: 'Clear',
            refresh: 'Refresh',
            reload: 'Reload',
            search: 'Search',
            filter: 'Filter',
            sort: 'Sort',
            select: 'Select',
            deselect: 'Deselect',
            selectAll: 'Select all',
            deselectAll: 'Deselect all',
            open: 'Open',
            view: 'View',
            preview: 'Preview',
            download: 'Download',
            upload: 'Upload',
            import: 'Import',
            export: 'Export',
            copy: 'Copy',
            duplicate: 'Duplicate',
            move: 'Move',
            back: 'Back',
            next: 'Next',
            previous: 'Previous',
            submit: 'Submit',
            retry: 'Retry',
        },

        status: {
            active: 'Active',
            inactive: 'Inactive',
            enabled: 'Enabled',
            disabled: 'Disabled',
            pending: 'Pending',
            draft: 'Draft',
            new: 'New',
            open: 'Open',
            closed: 'Closed',
            completed: 'Completed',
            cancelled: 'Cancelled',
            failed: 'Failed',
            successful: 'Successful',
            loading: 'Loading',
            processing: 'Processing',
            available: 'Available',
            unavailable: 'Unavailable',
        },

        validation: {
            required: 'This field is required.',
            invalid: 'Invalid value.',
            invalidFormat: 'Invalid format.',
            tooShort: 'The value is too short.',
            tooLong: 'The value is too long.',
            minValue: 'The value is too small.',
            maxValue: 'The value is too large.',
            invalidEmail: 'Invalid email address.',
            invalidDate: 'Invalid date.',
            invalidTime: 'Invalid time.',
            passwordsDoNotMatch: 'The passwords do not match.',
            valueAlreadyExists: 'This value already exists.',
        },

        messages: {
            success: 'Operation completed successfully.',
            error: 'An error occurred.',
            warning: 'Warning.',
            info: 'Information',
            noResults: 'No results found.',
            noData: 'No data available.',
            noItems: 'No items available.',
            loading: 'Loading data...',
            saving: 'Saving data...',
            deleting: 'Deleting data...',
            saved: 'Saved successfully.',
            deleted: 'Deleted successfully.',
            changesSaved: 'Changes have been saved.',
            unsavedChanges: 'There are unsaved changes.',
            confirmDelete: 'Are you sure you want to delete this item?',
            confirmDiscard: 'Are you sure you want to discard the changes?',
            operationFailed: 'The operation could not be completed.',
        },

        navigation: {
            home: 'Home',
            dashboard: 'Dashboard',
            overview: 'Overview',
            details: 'Details',
            list: 'List',
            form: 'Form',
            menu: 'Menu',
            actions: 'Actions',
            more: 'More',
            less: 'Less',
            expand: 'Expand',
            collapse: 'Collapse',
            first: 'First',
            last: 'Last',
            page: 'Page',
            of: 'of',
        },

        search: {
            search: 'Search',
            searchPlaceholder: 'Search...',
            searchFor: 'Search for',
            noResults: 'No results found.',
            results: 'Results',
            clear: 'Clear search',
            filters: 'Filters',
            activeFilters: 'Active filters',
            clearFilters: 'Clear filters',
        },

        pagination: {
            page: 'Page',
            of: 'of',
            first: 'First page',
            previous: 'Previous page',
            next: 'Next page',
            last: 'Last page',
            itemsPerPage: 'Items per page',
            showing: 'Showing',
            to: 'to',
            total: 'of',
        },

        sorting: {
            sortBy: 'Sort by',
            ascending: 'Ascending',
            descending: 'Descending',
            unsorted: 'Unsorted',
        },

        filters: {
            filterBy: 'Filter by',
            equals: 'Equals',
            notEquals: 'Does not equal',
            contains: 'Contains',
            notContains: 'Does not contain',
            startsWith: 'Starts with',
            endsWith: 'Ends with',
            greaterThan: 'Greater than',
            lessThan: 'Less than',
            greaterThanOrEqual: 'Greater than or equal to',
            lessThanOrEqual: 'Less than or equal to',
            between: 'Between',
            isEmpty: 'Is empty',
            isNotEmpty: 'Is not empty',
        },

        permissions: {
            access: 'Access',
            read: 'Read',
            write: 'Write',
            create: 'Create',
            update: 'Update',
            delete: 'Delete',
            view: 'View',
            manage: 'Manage',
            allowed: 'Allowed',
            denied: 'Denied',
            noPermission: 'You do not have permission.',
        },

        files: {
            file: 'File',
            files: 'Files',
            attachment: 'Attachment',
            attachments: 'Attachments',
            upload: 'Upload',
            download: 'Download',
            fileName: 'File name',
            fileSize: 'File size',
            fileType: 'File type',
            chooseFile: 'Choose file',
            noFile: 'No file selected.',
            invalidFileType: 'Unsupported file type.',
            fileTooLarge: 'The file is too large.',
        },

        user: {
            user: 'User',
            users: 'Users',
            account: 'Account',
            profile: 'Profile',
            email: 'Email',
            phone: 'Phone',
            firstName: 'First name',
            lastName: 'Last name',
            fullName: 'Full name',
            username: 'Username',
            password: 'Password',
            newPassword: 'New password',
            confirmPassword: 'Confirm password',
            language: 'Language',
            role: 'Role',
        },

        boolean: {
            yes: 'Yes',
            no: 'No',
            true: 'Yes',
            false: 'No',
        },

        units: {
            day: 'Day',
            days: 'Days',
            hour: 'Hour',
            hours: 'Hours',
            minute: 'Minute',
            minutes: 'Minutes',
            second: 'Second',
            seconds: 'Seconds',
            byte: 'Byte',
            bytes: 'Bytes',
            kilobyte: 'KB',
            megabyte: 'MB',
            gigabyte: 'GB',
            percent: '%',
        },
    },
    admin: {
        companySettings: {
            eyebrow:'Company',
            title:'General Settings for Company',
            description:'General Settings for your own Company',
        },
    },
    crm: {
        project: {},
        task: {
            shared: {
                title:'Tasks',
                effort: 'Effort',
                effortType: 'Effort-Type',
            },
            list: {},
            form: {
                efforts:{
                    heading:'Efforts',
                    addEffortType:'Add Effort Type',
                }
            },
            effortType:{
                existingEfforts:'Existing Efforts',
            },
            relation:{
                relatedTo:'Ist Verwandt mit',
                IsRequiredFor:'',
                DependsOn:'',
                IsDuplicateBy:'',
                Duplicates:'',
                IsParentFor:'',
                SubtaskOf:'',
            }
        },
        companies: {},
        contacts: {},
        workflow: {}
    }
}